import React from "react";
import { Field, FieldArray } from "formik";
import { TextField } from "formik-material-ui";
import { Grid, Button } from "../../..";
import { makeStyles } from "@material-ui/core/styles";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      "align-items": "center",
      "justify-content": "flex-start"
    },
    form: {
      display: "flex"
    },
    mr30: {
      "margin-right": "30px"
    },
    button: {
      width: "20px",
      "min-width": "20px",
      "margin-right": "10px"
    },
    email: {
      width: "50%",
      "margin-right": "30px"
    },
    flex: {
      display: "flex",
      "flex-wrap": "wrap"
    }
  };
});

var PersonOfContactForm = function PersonOfContactForm(_ref) {
  var values = _ref.values,
      mode = _ref.mode,
      translation = _ref.translation;
  // console.log('traanslation person of contact', translation);
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12
  }, /*#__PURE__*/React.createElement(FieldArray, {
    name: "people",
    render: function render(_ref2) {
      var insert = _ref2.insert,
          remove = _ref2.remove,
          push = _ref2.push;
      return values.people.length > 0 ? values.people.map(function (field, index) {
        return /*#__PURE__*/React.createElement(Grid, {
          item: true,
          md: 12,
          className: classes.root,
          key: index
        }, /*#__PURE__*/React.createElement(Field, {
          "data-cy": "name",
          name: "people[".concat(index, "].name"),
          key: "people[".concat(index, "].name"),
          label: translation ? translation.inputs.person_name : "Name",
          className: classes.mr30,
          component: TextField,
          margin: "normal",
          variant: "outlined",
          disabled: mode === "view"
        }), /*#__PURE__*/React.createElement(Field, {
          "data-cy": "job",
          name: "people[".concat(index, "].job"),
          key: "people[".concat(index, "].job"),
          className: classes.mr30,
          label: translation ? translation.inputs.person_job : "Job",
          component: TextField,
          margin: "normal",
          variant: "outlined",
          disabled: mode === "view"
        }), /*#__PURE__*/React.createElement(Field, {
          "data-cy": "email",
          name: "people[".concat(index, "].email"),
          key: "people[".concat(index, "].email"),
          className: classes.mr30,
          label: translation ? translation.inputs.person_email : "Email",
          component: TextField,
          margin: "normal",
          variant: "outlined",
          disabled: mode === "view"
        }), /*#__PURE__*/React.createElement(Field, {
          "data-cy": "telephone",
          name: "people[".concat(index, "].telephone"),
          key: "people[".concat(index, "].telephone"),
          label: translation ? translation.inputs.person_phone : "Phone",
          className: classes.mr30,
          component: TextField,
          margin: "normal",
          variant: "outlined",
          disabled: mode === "view"
        }), mode === "add" && /*#__PURE__*/React.createElement(Button, {
          "data-cy": "delete",
          key: "delete",
          className: classes.button,
          disabled: values.people.length === 1 || mode === "view",
          type: "button",
          color: "secondary",
          variant: "outlined",
          onClick: function onClick() {
            return remove(index);
          }
        }, "-"), mode === "add" && /*#__PURE__*/React.createElement(Button, {
          "data-cy": "new",
          key: "new",
          type: "button",
          className: classes.button,
          color: "primary",
          disabled: mode === "view",
          variant: "outlined",
          onClick: function onClick() {
            push({
              name: "",
              job: "",
              email: "",
              telephone: "",
              type: "person"
            });
          }
        }, "+"));
      }) : /*#__PURE__*/React.createElement(Button, {
        "data-cy": "add",
        key: "add",
        type: "button",
        className: classes.mr30,
        size: "small",
        color: "primary",
        variant: "outlined",
        disabled: mode === "view",
        onClick: function onClick() {
          return push({
            name: "",
            job: "",
            email: "",
            telephone: "",
            type: "person"
          });
        }
      }, translation ? translation.buttons.add_person_of_contact : "Add user");
    }
  })));
};

PersonOfContactForm.defaultProps = {
  mode: "add",
  central: false
};
export { PersonOfContactForm };